<template>
  <Navbar bgimage="Logo_Digiasia_Color.png" />
  <Content />
  <Footer />
  <Copyright />
</template>

<script>
import Navbar from "@/components/portal/Navbar.vue";
import Content from "@/components/portal/NewsRoomDetailsContent.vue";
import Footer from "@/components/portal/PageFooterSecond.vue";
import Copyright from "@/components/portal/PageCopyright.vue";

export default {
  name: "OurValue",
  components: {
    Navbar,
    Content,
    Footer,
    Copyright,
  },
};
</script>
